import { TRANSLATION } from '@aipb/gulliver/translation';
import { inject, Injectable } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';
import merge from 'lodash-es/merge';
import { from, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoImportLoader implements TranslocoLoader {
  private translation = inject(TRANSLATION);

  getTranslation(lang: string) {
    return from(import(`./i18n/${lang}.json`)).pipe(
      map((t) => merge(t, this.translation && lang in this.translation ? this.translation[lang] : {}))
    );
  }
}
